(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ib-left-sidebar"] && !Shopify.designMode) return;
  try {
    
(function initIbLeftSidebar() {
  const roots = document.querySelectorAll('[data-ib-sidebar]');
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('.ib-sidebar-account').forEach(function bindAccount(wrap) {
    if (wrap.dataset.ibAccountBound === 'true') return;

    const accountHost = wrap.querySelector('shopify-account.ib-sidebar-account__shopify');
    const accountTrigger = wrap.querySelector('[data-ib-sidebar-account-trigger]');
    if (!accountHost || !accountTrigger) return;

    wrap.dataset.ibAccountBound = 'true';

    function syncIbSidebarAccountPosition() {
      const rect = accountTrigger.getBoundingClientRect();
      accountHost.style.setProperty(
        '--shopify-account-dialog-position-top',
        Math.round(rect.bottom + 8) + 'px'
      );
      accountHost.style.setProperty('--ib-account-dialog-left', Math.round(rect.left) + 'px');
    }

    function openIbSidebarAccount() {
      syncIbSidebarAccountPosition();
      const open = function openAccountModal() {
        if (typeof accountHost.showModal === 'function') {
          accountHost.showModal();
        }
      };

      if (customElements.get('shopify-account')) {
        open();
        return;
      }

      if (customElements.whenDefined) {
        customElements.whenDefined('shopify-account').then(open);
      }
    }

    accountTrigger.addEventListener('click', function handleAccountTriggerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      openIbSidebarAccount();
    });
  });

  roots.forEach(function bindSidebar(root) {
    const dialog = root.querySelector('[data-ib-sidebar-dialog]');
    const openButton = root.querySelector('[data-ib-sidebar-open]');
    const closeButton = root.querySelector('[data-ib-sidebar-close]');

    if (!dialog || !openButton) return;

    function syncIbSidebarToViewport() {
      if (desktopQuery.matches) {
        if (dialog.matches(':modal') && typeof dialog.close === 'function') {
          dialog.close();
        }
        dialog.setAttribute('open', '');
        return;
      }

      if (!dialog.matches(':modal')) {
        dialog.removeAttribute('open');
      }
    }

    function openIbSidebarDrawer(event) {
      if (desktopQuery.matches) return;
      if (event) event.preventDefault();
      if (typeof window.ibToggleSharedMobileMenu === 'function') {
        window.ibToggleSharedMobileMenu();
        return;
      }
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }

    function closeIbSidebarDrawer() {
      if (desktopQuery.matches) return;
      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      }
    }

    openButton.addEventListener('click', openIbSidebarDrawer);

    if (closeButton) {
      closeButton.addEventListener('click', closeIbSidebarDrawer);
    }

    dialog.addEventListener('click', function handleBackdropClick(event) {
      if (event.target === dialog) {
        closeIbSidebarDrawer();
      }
    });

    dialog.addEventListener('click', function handleMenuNavigation(event) {
      const link = event.target.closest('a');
      if (link && dialog.contains(link) && !desktopQuery.matches) {
        closeIbSidebarDrawer();
      }
    });

    desktopQuery.addEventListener('change', syncIbSidebarToViewport);
    syncIbSidebarToViewport();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
/** Measure each slide image and lock mobile slides to the shortest height. */
(function initIbSlideshowMobileUniform() {
  const query = window.matchMedia('(max-width: 749px)');

  function slideImageHeight(slide) {
    const media = slide.querySelector('.slide__image, .slide__video-poster, .slide__video');
    if (!media) return 0;

    const boxWidth = slide.getBoundingClientRect().width;
    if (boxWidth <= 0) return 0;

    const naturalWidth = media.naturalWidth || media.videoWidth || Number(media.getAttribute('width')) || 0;
    const naturalHeight = media.naturalHeight || media.videoHeight || Number(media.getAttribute('height')) || 0;
    if (naturalWidth <= 0 || naturalHeight <= 0) return 0;

    return boxWidth * (naturalHeight / naturalWidth);
  }

  function originalSlides(root) {
    const slides = Array.from(root.querySelectorAll('slideshow-slides > slideshow-slide'));
    const originals = slides.filter(function skipClone(slide) {
      return !slide.hasAttribute('data-ib-marquee-clone');
    });
    return originals.length ? originals : slides;
  }

  function syncUniformHeight(root) {
    if (!query.matches) {
      root.style.removeProperty('--slide-uniform-aspect');
      return;
    }

    const slides = originalSlides(root);
    let minHeight = Infinity;
    let width = 0;

    slides.forEach(function measureSlide(slide) {
      const height = slideImageHeight(slide);
      if (height <= 0) return;
      if (height < minHeight) {
        minHeight = height;
        width = slide.getBoundingClientRect().width;
      }
    });

    if (minHeight === Infinity || width <= 0) return;

    root.style.setProperty('--slide-uniform-aspect', String(width / minHeight));
  }

  document.querySelectorAll('.slideshow-section slideshow-component.slideshow--mobile-uniform').forEach(function bindUniform(root) {
    const run = function runUniform() {
      syncUniformHeight(root);
    };

    run();
    root.querySelectorAll('img, video').forEach(function bindMedia(media) {
      if (media.tagName === 'IMG' && !media.complete) {
        media.addEventListener('load', run, { once: true });
      }
      if (media.tagName === 'VIDEO') {
        media.addEventListener('loadedmetadata', run, { once: true });
      }
    });
    query.addEventListener('change', run);
    window.addEventListener('resize', run);
  });
})();

(function initIbSlideshowMarquee() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-ib-slideshow-marquee]').forEach(function bindMarquee(root) {
    const scroller = root.querySelector('slideshow-slides');
    if (!scroller || scroller.dataset.ibMarqueeReady === 'true') return;

    const originals = Array.from(scroller.querySelectorAll(':scope > slideshow-slide'));
    if (originals.length < 2) return;

    const isNarrowPhone = window.matchMedia('(max-width: 749px)').matches;
    if (isNarrowPhone) {
      const speed = root.getAttribute('data-ib-marquee-speed') || '3';
      if (!root.hasAttribute('autoplay')) {
        root.setAttribute('autoplay', speed);
      }
      if (typeof root.resume === 'function') {
        root.resume();
      }
      return;
    }

    if (typeof root.disabled !== 'undefined') {
      root.disabled = true;
    } else {
      root.setAttribute('disabled', 'true');
    }

    scroller.scrollLeft = 0;
    scroller.dataset.ibMarqueeReady = 'true';

    if (reducedMotion) return;

    originals.forEach(function cloneSlide(slide) {
      const clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-ib-marquee-clone', '');
      scroller.appendChild(clone);
    });

    const clones = Array.from(scroller.querySelectorAll('[data-ib-marquee-clone]'));
    const speedSeconds = Number(root.getAttribute('data-ib-marquee-speed') || 4);
    let loopWidth = 0;
    let offset = 0;
    let hovering = false;
    let offscreen = false;
    let paused = false;
    let lastTime = 0;

    function lockSlideWidths() {
      const progress = loopWidth > 0 ? offset / loopWidth : 0;

      root.classList.remove('ib-marquee-ready');
      originals.concat(clones).forEach(function unlockSlide(slide) {
        slide.style.width = '';
        slide.style.maxWidth = '';
        slide.style.flex = '';
      });

      void scroller.offsetWidth;

      originals.forEach(function lockOriginal(slide, index) {
        const width = slide.getBoundingClientRect().width;
        if (width <= 0) return;

        const locked = width + 'px';
        slide.style.width = locked;
        slide.style.maxWidth = 'none';
        slide.style.flex = '0 0 ' + locked;

        const clone = clones[index];
        if (clone) {
          clone.style.width = locked;
          clone.style.maxWidth = 'none';
          clone.style.flex = '0 0 ' + locked;
        }
      });

      root.classList.add('ib-marquee-ready');
      void scroller.offsetWidth;

      const firstClone = clones[0];
      loopWidth = firstClone ? firstClone.offsetLeft : 0;
      offset = progress * loopWidth;
      applyOffset();
    }

    function pixelsPerMs() {
      if (loopWidth <= 0) return 0;
      return loopWidth / (originals.length * speedSeconds * 3 * 1000);
    }

    function currentIndex() {
      let best = 0;
      let bestDist = Infinity;
      originals.forEach(function findNearest(slide, index) {
        const distance = Math.abs(offset - slide.offsetLeft);
        if (distance < bestDist) {
          bestDist = distance;
          best = index;
        }
      });
      return best;
    }

    function updateDots(index) {
      root.querySelectorAll('slideshow-controls ol button').forEach(function syncDot(dot, dotIndex) {
        if (dotIndex === index) {
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    function applyOffset() {
      if (loopWidth > 0) {
        offset = ((offset % loopWidth) + loopWidth) % loopWidth;
      }
      scroller.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      updateDots(currentIndex());
    }

    let resumeTimer = 0;
    function holdForControl() {
      hovering = true;
      syncPaused();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function resumeAfterControl() {
        hovering = root.matches(':hover') || root.contains(document.activeElement);
        syncPaused();
      }, 2500);
    }

    function goTo(index) {
      const target = ((index % originals.length) + originals.length) % originals.length;
      const slide = originals[target];
      if (!slide) return;
      offset = slide.offsetLeft;
      applyOffset();
      holdForControl();
    }

    function syncPaused() {
      const nextPaused = hovering || offscreen;
      if (paused && !nextPaused) lastTime = 0;
      paused = nextPaused;
    }

    function tick(time) {
      if (!lastTime) lastTime = time;
      const delta = time - lastTime;
      lastTime = time;

      if (!paused && loopWidth > 0) {
        offset += pixelsPerMs() * delta;
        applyOffset();
      }

      window.requestAnimationFrame(tick);
    }

    lockSlideWidths();
    window.requestAnimationFrame(tick);

    root.addEventListener('mouseenter', function onEnter() {
      hovering = true;
      syncPaused();
    });
    root.addEventListener('mouseleave', function onLeave() {
      hovering = false;
      syncPaused();
    });
    root.addEventListener('focusin', function onFocusIn() {
      hovering = true;
      syncPaused();
    });
    root.addEventListener('focusout', function onFocusOut(event) {
      if (!root.contains(event.relatedTarget)) {
        hovering = false;
        syncPaused();
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function onIntersect(entries) {
        entries.forEach(function syncOffscreen(entry) {
          offscreen = !entry.isIntersecting;
          syncPaused();
        });
      }, { threshold: 0.15 });
      observer.observe(root);
    }

    window.addEventListener('resize', lockSlideWidths);

    scroller.querySelectorAll('img').forEach(function bindImage(image) {
      if (image.complete) return;
      image.addEventListener('load', lockSlideWidths, { once: true });
    });

    root.addEventListener(
      'click',
      function onControlClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const previous = target.closest('.slideshow-control--previous');
        const next = target.closest('.slideshow-control--next');
        const dot = target.closest('slideshow-controls ol button');
        if (!previous && !next && !dot) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (previous) {
          goTo(currentIndex() - 1);
          return;
        }
        if (next) {
          goTo(currentIndex() + 1);
          return;
        }

        const dots = Array.from(root.querySelectorAll('slideshow-controls ol button'));
        goTo(dots.indexOf(dot));
      },
      true
    );
  });
})();

  } catch(e) { console.error(e); }
})();
})();
